import { combineReducers } from 'redux'
import appUser from './appUser'
import cixiReferent from './cixiReferent'
import company from './company'
import companyCategory from './companyCategory'
import companyPerLink from './companyPerLink'
import companyRole from './companyRole'
import conditionalFeature from './conditionalFeature'
import country from './country'
import currency from './currency'
import dateTimeFormat from './dateTimeFormat'
import electronicKey from './electronicKey'
import electronicKeyModel from './electronicKeyModel'
import keyUsageSystemLog from './keyUsageSystemLog'
import label from './label'
import language from './language'
import logMail from './logMail'
import logRoutine from './logRoutine'
import mailTemplate from './mailTemplate'
import message from './message'
import modelPer from './modelPer'
import notificationRequest from './notificationRequest'
import notificationTemplate from './notificationTemplate'
import per from './per'
import persPackage from './persPackage'
import platformPageTech from './platformPageTech'
import role from './role'
import rolesConfiguration from './rolesConfiguration'
import section from './section'
import serviceCenterAdmin from './serviceCenterAdmin'
import sharing from './sharing'
import showcaseAnonymizeVisitor from './showcaseAnonymizeVisitor'
import showcaseContactLog from './showcaseContactLog'
import showcasePrivacyPolicy from './showcasePrivacyPolicy'
import showcaseStory from './showcaseStory'
import subscription from './subscription'
import systemConfig from './systemConfig'
import timezone from './timezone'
import usageSystemLog from './usageSystemLog'
import user from './user'
import vehicle from './vehicle'
import vehicleBrand from './vehicleBrand'
import vehicleModel from './vehicleModel'
import vehicleType from './vehicleType'

export default combineReducers({
  company,
  vehicle,
  appUser,
  electronicKey,
  electronicKeyModel,
  modelPer,
  vehicleModel,
  cixiReferent,
  language,
  currency,
  country,
  timezone,
  label,
  message,
  user,
  role,
  rolesConfiguration,
  systemConfig,
  dateTimeFormat,
  logMail,
  logRoutine,
  subscription,
  section,
  mailTemplate,
  showcaseStory,
  vehicleBrand,
  showcasePrivacyPolicy,
  showcaseContactLog,
  conditionalFeature,
  showcaseAnonymizeVisitor,
  sharing,
  per,
  platformPageTech,
  notificationTemplate,
  notificationRequest,
  keyUsageSystemLog,
  usageSystemLog,
  persPackage,
  companyCategory,
  companyRole,
  serviceCenterAdmin,
  companyPerLink,
  vehicleType
})
